import axios from 'axios';
import { logError } from 'Utils/Logger';
import { isNonAnonymousUser, getAccessToken } from 'Utils/UserCookie';
import { createApiTokenHandler } from './RefreshTokenHandler';

export class RequestService {
  static async send(config) {
    const { authenticate = false, customHeaders = {} } = config;

    try {
      return await createApiTokenHandler(async () => {
        const token = isNonAnonymousUser() && getAccessToken();

        const headers = customHeaders;

        if (authenticate && token) {
          headers.Authorization = `Bearer ${token}`;
        }

        return axios({ ...config, headers });
      });
    } catch (e) {
      logError(e?.response?.data?.errorMessage || e);
      throw e;
    }
  }
}
